// Pure helpers for the admin call browser (unit-tested in adminUtils.test.ts).

/** Keycloak realm role that grants access to the admin call/recording browser. */
export const ADMIN_ROLE = 'iris_admin'

/** True if the Keycloak realm roles include the admin role. */
export const hasAdminRole = (roles: string[] | undefined | null): boolean =>
  Array.isArray(roles) && roles.includes(ADMIN_ROLE)

/** Format a call duration (seconds) as m:ss, or an em dash when unknown. */
export const formatDuration = (seconds?: number | null): string => {
  if (seconds == null || seconds < 0) return '—'
  const m = Math.floor(seconds / 60)
  const s = Math.floor(seconds % 60)
  return `${m}:${String(s).padStart(2, '0')}`
}

/** Format an ISO timestamp for display, or an em dash when absent/invalid. */
export const formatDateTime = (iso?: string | null): string => {
  if (!iso) return '—'
  const d = new Date(iso)
  return isNaN(d.getTime()) ? '—' : d.toLocaleString()
}
